import Shape1 from "../../../assets/web/images/shape-1.svg";
import TrustedPartners from "../../../assets/web/images/trusted-partners.png";
import Container from "../Container";

const TrustedBy = () => {
  return (
    <section className="py-20">
      <Container>
        <div className="max-w-3xl mx-auto">
          <div className="text-3xl md:text-5xl text-center font-bold text-textHeading">
            <div>
              Trusted By{" "}
              <span className="relative">
                <span>1000+</span>
                <img
                  src={Shape1}
                  className="absolute bottom-0 left-[50%] -translate-x-[50%]"
                  alt=""
                />
              </span>
            </div>
            <div>Businesses in Bangladesh</div>
          </div>

          <div className="my-10">
            <img
              src={TrustedPartners}
              className="w-full"
              alt="Trusted Partners"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default TrustedBy;
